import { cloneElement, useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import ExamLoader from "./ExamLoader";

export default function ProtectedRoute({ children }) {
  const { examId } = useParams();
  const [status, setStatus] = useState("loading"); // loading | ok | reject
  const [session, setSession] = useState(null);
  const [checkedExamId, setCheckedExamId] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setStatus("loading");
    fetch("/api/session", { credentials: "include", cache: "no-store" })
      .then(res => res.ok ? res.json() : null)
      .then(data => {
        if (cancelled) return;
        if (!data?.active) {
          setStatus("reject");
          return;
        }

        // 🔒 level mismatch
        if (examId && data.examId !== examId) {
          //setStatus("reject");
          //return;
        }

        setSession(data);
        setCheckedExamId(examId);
        setStatus("ok");
      })
      .catch(() => { if (!cancelled) setStatus("reject"); });
    return () => { cancelled = true; };
  }, [examId]);

  if (status === "loading" || (status === "ok" && checkedExamId !== examId)) {
    return <ExamLoader />;
  }

  if (status === "reject") {
    return <Navigate to="/login" replace />;
  }

  return cloneElement(children, {
    key: `${session.draftSessionId || "session"}:${examId}`,
    examSession: session
  });
}
